import ListTemplate from "../_templates/ListTemplate";
import BulkDeleteAction from "../../../components/common/BulkDeleteAction";
import { listStadiums, deleteStadium } from "../../../api/coredata.api";
import useNationalities from "../../../hooks/useNationalities";
import useAuthStore from "../../../store/auth.store";

export default function StadiumList() {
  const { nameOf } = useNationalities();
  const isSuperuser = useAuthStore((s) => !!s.user?.is_superuser);
  return (
    <ListTemplate
      title="Stadiums"
      fetchFn={listStadiums}
      deleteFn={deleteStadium}
      getAddPath={() => "/cricket/stadiums/add"}
      getEditPath={(id) => `/cricket/stadiums/${id}/edit`}
      bulkActions={isSuperuser ? (ids, reset, reload) => (
        <BulkDeleteAction ids={ids} deleteFn={deleteStadium} label="stadiums" reset={reset} reload={reload} />
      ) : undefined}
      columns={[
        { key: "name",        label: "Stadium",   render: (r) => <span className="font-medium">{r.name}</span> },
        { key: "city",        label: "City" },
        { key: "nationality", label: "Country",   render: (r) => nameOf(r.nationality), sortValue: (r) => nameOf(r.nationality) },
        { key: "time_zone",   label: "Time zone", render: (r) => <span className="text-text-secondary text-xs font-mono">{r.time_zone || "—"}</span> },
        { key: "established_year", label: "Est.", render: (r) => r.established_year || "—" },
        { key: "floodlights", label: "Lights",    render: (r) => r.floodlights ? `${r.floodlights}` : "—" },
      ]}
    />
  );
}
